import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-search-input',
  standalone: true,
  imports: [FormsModule, SvgIconComponent],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent {
  @Input() placeholder = 'Search ...';
  @Input() searchQuery = '';
  @Input() disableSearch = false;
  @Output() searchQueryChange = new EventEmitter<string>();

  onModelChange(value: string) {
    this.searchQuery = value;
    this.searchQueryChange.emit(value);
  }

  clearSearch() {
    this.searchQuery = '';
    this.searchQueryChange.emit('');
  }
}
